'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.GruposService
 * @description
 * # GruposService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('GruposService', function($http) {
  return {
    list: function() {
      return $http.get(SERVER + API_VERSION + 'grupos');
    }
  };
});